<template>
  <div class="main-list-wrapper">
    <display-swipe :items="swipes" />
    <div class="tabs-wrapper">
      <van-tabs v-model="active">
        <van-tab v-for="item of tabs" :key="item.id" :title="item.title" :name="item.id"></van-tab>
      </van-tabs>
    </div>
    <collapse-spots
      v-show="active === 1"
      :spots="spots"
      :navigationEnabled="navigationEnabled"
      @navigate="onNavigate"
    />
    <collapse-tickets v-show="active !== 1" :tickets="tickets" />
  </div>
</template>
<script>
import wx from 'jweixin-module';
import { mapGetters } from 'vuex';
import { getSpotsSlides, getSpots, getSpotsTickets } from '@/api/api-ticket';
import DisplaySwipe from '@/components/DisplaySwipe';
import CollapseSpots from './CollapseSpots';
import CollapseTickets from './CollapseTickets';

export default {
  components: {
    DisplaySwipe,
    CollapseSpots,
    CollapseTickets,
  },
  data() {
    return {
      active: 1,
      tabs: [
        { id: 1, title: '景区列表' },
        { id: 2, title: '联票列表' },
      ],
      swipes: [],
      wechatConfig: {},
      navigationEnabled: false,
      location: {},
      spots: [],
      tickets: [],
    };
  },
  computed: {
    ...mapGetters(['wechatUrl']),
  },
  mounted() {
    // make sure wechat url processed
    setTimeout(() => {
      this.handleGet();
    }, 0);
  },
  methods: {
    initMapDirection(config) {
      wx.ready(() => {
        wx.getLocation({
          type: 'wgs84',
          success: ({ latitude: lat, longitude: lng }) => {
            this.fetchData({ lat, lng });
          },
          cancel: () => {
            this.fetchData();
          },
        });
      });
      wx.config(config);
    },
    onNavigate(data) {
      wx.openLocation(data);
    },
    async handleGet() {
      try {
        const { wechat, jssdk: config, site_slides: slides } = await getSpotsSlides({
          url: this.wechatUrl || window.location.href,
        });
        this.swipes = slides;
        this.navigationEnabled = !!wechat;
        if (wechat) {
          this.initMapDirection(config);
        } else {
          this.fetchData();
        }
      } catch {}
    },
    fetchData(location) {
      this.handleGetSpots(location);
      this.handleGetTickets();
    },
    async handleGetSpots(location) {
      try {
        const data = await getSpots(location);
        this.spots = data;
      } catch {}
    },
    async handleGetTickets() {
      try {
        const { list } = await getSpotsTickets();
        this.tickets = list;
      } catch {}
    },
  },
};
</script>
<style lang="less" scoped>
.main-list-wrapper {
  background: #fff;
  margin-bottom: 50px;
}
</style>
